(function () {
  var SECTION_SELECTOR = '.oddit-section-card-carousel';

  function initSection(section) {
    var track = section.querySelector('.oddit-section-card-carousel__track');
    var prevBtn = section.querySelector('.oddit-section-card-carousel__nav-button--prev');
    var nextBtn = section.querySelector('.oddit-section-card-carousel__nav-button--next');
    var progressFill = section.querySelector('.oddit-section-card-carousel__progress-fill');

    if (!track) return;

    function getSlideStep() {
      var slide = track.querySelector('.oddit-section-card-carousel__slide');
      if (!slide) return 0;
      var styles = window.getComputedStyle(track);
      var gap = parseInt(styles.columnGap || styles.gap || '0', 10) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function updateProgress() {
      if (!progressFill) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      // Progress fill width grows from a minimum visible width up to 100%
      var minWidth = 15;
      var widthPct = minWidth + (100 - minWidth) * ratio;
      progressFill.style.width = widthPct + '%';
    }

    function updateNavState() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
    }

    function scrollByStep(direction) {
      var step = getSlideStep();
      if (step <= 0) return;
      track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByStep(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByStep(1);
      });
    }

    track.addEventListener('scroll', function () {
      updateProgress();
      updateNavState();
    }, { passive: true });

    // Desktop mouse drag (mouse only — touch keeps native scroll-snap swipe)
    var dragActive = false;
    var dragMoved = false;
    var dragStartX = 0;
    var dragLastX = 0;

    function onPointerDown(e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (typeof e.button === 'number' && e.button !== 0) return;
      dragActive = true;
      dragMoved = false;
      dragStartX = e.clientX;
      dragLastX = e.clientX;
      track.classList.add('is-dragging');
    }

    function onPointerMove(e) {
      if (!dragActive) return;
      var dx = e.clientX - dragLastX;
      dragLastX = e.clientX;
      if (Math.abs(e.clientX - dragStartX) > 4) dragMoved = true;
      track.scrollLeft -= dx;
    }

    function endDrag() {
      if (!dragActive) return;
      dragActive = false;
      track.classList.remove('is-dragging'); // snap re-enables and settles to nearest
      updateProgress();
      updateNavState();
    }

    function onDragClick(e) {
      // Swallow the click that ends a drag so cards/links don't activate
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }
    }

    function onDragStart(e) {
      // Block the browser's native image/link drag so a drag that STARTS on a
      // card image or link still scrolls the track instead of ghost-dragging.
      e.preventDefault();
    }

    track.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', onDragClick, true);
    track.addEventListener('dragstart', onDragStart);

    // Initial state
    updateProgress();
    updateNavState();

    // Re-sync on resize
    var resizeObserver = new ResizeObserver(function () {
      updateProgress();
      updateNavState();
    });
    resizeObserver.observe(track);

    // Teardown: drop window-level listeners + observer when the section reloads
    section._odditTeardown = function () {
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerup', endDrag);
      window.removeEventListener('pointercancel', endDrag);
      resizeObserver.disconnect();
    };
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section && typeof section._odditTeardown === 'function') section._odditTeardown();
  });
})();